import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthenticationService } from '@tylertech/cj-jpp-ui-core/authentication';
import { InstanceManagerService } from "../services/instance-manager.service";
import { from, lastValueFrom, Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { TimsTokenService } from "../services/tims-token.service";

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private instanceManagerService: InstanceManagerService,
    private jitTokenService: TimsTokenService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.asyncIntercept(request, next));
  }

  private async asyncIntercept(request: HttpRequest<any>, next: HttpHandler) {
    const token = (this.jitTokenService.isValid ? this.jitTokenService.token : null) ??
      this.instanceManagerService.instanceTokenSnapshot ?? this.authService.getAccessToken();

    if (!request.url.startsWith(environment.ServiceApiUrl)) {
      return lastValueFrom(next.handle(request));
    }
    return await lastValueFrom(next.handle(
      request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    ));

  }
}